import type { AssignmentVersion } from "@/lib/api/assignments";
import type { TeachingDraftHeader } from "@/lib/api/teachingDrafts";
import { atCourseTime } from "./use-team-names";

const FACTS: { label: string; of: (version: AssignmentVersion) => unknown }[] = [
  { label: "Title", of: version => version.title },
  { label: "Instructions", of: version => version.instructions ?? "" },
  { label: "Points", of: version => version.points },
  { label: "Due", of: version => version.due_at },
  { label: "Hand-in", of: version => version.expected_deliverable },
  { label: "Assessment", of: version => version.assessment_kind },
  { label: "Rubric", of: version => JSON.stringify(version.rubric ?? null) },
  { label: "Grading scale", of: version => JSON.stringify(version.scale ?? null) },
];

/** The facts one publication changed from the version before it. */
export function changedFacts(version: AssignmentVersion, before: AssignmentVersion | undefined): string[] {
  if (!before) return [];
  return FACTS.filter(fact => fact.of(version) !== fact.of(before)).map(fact => fact.label);
}

/** Whether a row is new work or corrects a published version: the purpose a same-title row lacks. */
export const draftRelation = (row: TeachingDraftHeader) => !row.assignment_id ? "New coursework" : row.base_version_no ? `Correction to version ${row.base_version_no}` : "Correction";
/** "Saved Sun, Nov 8, 8:49 AM New York time by Fatima": who to ask, without opening it. */
export const draftSaved = (row: TeachingDraftHeader, timezone: string, name: (id: string) => string | null) => {
  const who = name(row.saved_by);
  if (!row.saved_at) return who ? `Saved by ${who}` : "Saved";
  return `Saved ${atCourseTime(row.saved_at, timezone)}${who ? ` by ${who}` : ""}`;
};

